import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router";
import InfiniteScrollComponent from "../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import { getShotClassesActionHandler } from "../../../store/actions/actionHandlers/distributeActionHandler";
import DistributeClassList from "./DistributeClassList";
import classes from "./DistributeClass.module.scss";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import {
  setSelectedShotclassDataAction,
  setShotclassDataAction,
} from "../../../store/actions/actionCreators/distributeActionCreator";
import Loader from "../../../components/Common/Loader/Loader";

const DistributeClass = () => {
  const dispatch = useDispatch();
  const pageSize = 9;
  const { shotClassCount, loading, setLoading } = useOutletContext();
  const distributeState = useSelector((state) => state.distributeReducer);
  const { selctedShotclassData, shotclassData } = distributeState;
  const [pageNum, setPageNum] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);

  useEffect(() => {
    if (pageNum > 1)
      dispatch(
        getShotClassesActionHandler(
          "WithoutVTLT",
          false,
          "Published",
          "ShotClass",
          "none",
          "none",
          pageNum,
          pageSize,
          setLoading
        )
      );
  }, [dispatch, pageNum, setLoading]);

  const fetchMoreData = () => {
    if (shotclassData?.length >= shotClassCount) {
      setHasMoreData(false);
      return;
    }
    setPageNum((prevState) => prevState + 1);
  };

  const handleCheckboxChange = (e, data) => {
    if (e?.target?.checked) {
      dispatch(setSelectedShotclassDataAction([...selctedShotclassData, data]));
      const updatedData = shotclassData?.map((item) => {
        return {
          ...item,
          ShotClass: {
            ...item.ShotClass,
            checked:
              data?.ID === item?.ShotClass?.ID || item?.ShotClass?.checked
                ? true
                : false,
          },
        };
      });
      dispatch(setShotclassDataAction(updatedData));
    } else {
      const updatedData = selctedShotclassData?.filter((item) => {
        return item?.ID !== data?.ID;
      });
      dispatch(setSelectedShotclassDataAction(updatedData));
      const selectedpdatedData = shotclassData?.map((item) => {
        return {
          ...item,
          ShotClass: {
            ...item.ShotClass,
            checked:
              data?.ID === item?.ShotClass?.ID && item?.ShotClass?.checked
                ? false
                : item?.ShotClass?.checked
                ? true
                : false,
          },
        };
      });
      dispatch(setShotclassDataAction(selectedpdatedData));
    }
  };

  return (
    <BoxLayout>
      {loading && (
        <div className={classes.shotclassLoader}>
          <Loader />
        </div>
      )}
      {shotclassData?.length === 0 && !loading && (
        <div className={classes.classNotFoundText}>No Class Found</div>
      )}
      {shotClassCount > pageSize && shotclassData?.length > 0 && !loading && (
        <InfiniteScrollComponent
          dataLength={shotclassData?.length ? shotclassData.length : pageSize}
          fetchMoreData={fetchMoreData}
          hasMoreData={hasMoreData}
          height={"70rem"}
          loader={true}
        >
          <DistributeClassList
            classData={shotclassData}
            handleCheckboxChange={handleCheckboxChange}
          />
        </InfiniteScrollComponent>
      )}
      {shotClassCount <= pageSize && shotclassData?.length > 0 && !loading && (
        <DistributeClassList
          classData={shotclassData}
          handleCheckboxChange={handleCheckboxChange}
        />
      )}
      {/* {(selctedShotclassData?.length > 0 ||
        selctedSeriesData?.length > 0 ||
        selctedCollectionData?.length > 0) && (
        <DistributeFooter tenantName={tenantName} />
      )} */}
    </BoxLayout>
  );
};

export default DistributeClass;
